import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import isPage from '../hoc/isPage';
import validator from 'email-validator';
import { Input } from '@progress/kendo-react-inputs';
import { Button } from "@progress/kendo-react-buttons";
import { validatePasswordComplexity } from '../helpers';
import config from '../config/config';
import NotFound from './NotFound';
import { AppContext } from '../context/AppContext';

class RegisterPage extends Component {
    static propTypes = {
        registrationGuid: PropTypes.string
    }

    state = {
        email: "",
        password: "",
        navigateBack: false,
        accountCreated: false,
        navigateToNotFound: false // if the guid passed in is invalid, kick user over to NotFound page
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    validate = () => {
        const pass = this.state.password;

        // ensure at least one lowercase, one uppercase, one number
        return validatePasswordComplexity(pass);
    }
    createAccount = () => {

        if (!validator.validate(this.state.email)) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0306"));
            return;
        }
        if (!this.validate()) {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0307"));
            return;
        }

        const payload = {
            email: this.state.email,
            password: this.state.password
        }

        this.props.postData("/api/portal/user/RegisterUser", payload).then(response => {
            this.setState({
                accountCreated: true
            });
        }).catch(error => {
            this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0308"));
        });


    }
    closeRegistration = () => {
        this.setState({
            navigateBack: true
        });
    }
    componentDidMount() {
        const { registrationGuid } = this.props;
        if (registrationGuid !== config.registrationGuid) {
            this.setState({
                navigateToNotFound: true
            });
        }
        var lang = navigator.language || navigator.userLanguage;
        this.context.setLanguage(lang.slice(0, 2))
    }
    render() {

        if (this.state.navigateBack) {
            return <Redirect to="/" />
        }
        if (this.state.navigateToNotFound) {
            return <NotFound />
        }

        // show different content depending on whether account has been created yet
        const content = (this.state.accountCreated) ? (
            <React.Fragment>
                <h1>{this.props.returnLocalizedString("m0036")}</h1>
                <p>{this.props.returnLocalizedString("m0309")}</p>
            </React.Fragment>
        ) : (
                <React.Fragment>
                    <h1>{this.props.returnLocalizedString("m0310")}</h1>
                    <div className="warning">
                        <img className="icon" src={require('../img/icon-warning.png')} alt="" />
                        {this.props.returnLocalizedString("m0311")}
                </div>

                    <Input type="email" onChange={this.handleChange} required={true} label="Email" name='email' value={this.state.email} />
                    <div className="bottom-margin-10">
                        <Input type="password" onChange={this.handleChange} required={true} label="Password" name='password' value={this.state.password} />
                    </div>
                    <div className="bottom-margin-20">
                        {this.props.returnLocalizedString("m0312")}
                </div>
                    <Button primary={true} onClick={this.createAccount}>{this.props.returnLocalizedString("m0313")}</Button>
                </React.Fragment>
            );

        //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status
        //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status
        //!DBTRANS! @m0306@ Your email isn't properly formatted. Try again. !DEVNOTE! Action status reason
        //!DBTRANS! @m0307@ Your password has not met the minimum requirements. !DEVNOTE! Action status reason
        //!DBTRANS! @m0308@ The user account could not be registered. Please ensure that you have not previously registered this email in the system.!DEVNOTE! Action status
        //!DBTRANS! @m0309@ Now please check your email to verify your account. !DEVNOTE! Text
        //!DBTRANS! @m0310@ Register !DEVNOTE! Option label
        //!DBTRANS! @m0311@ For SOM pre-authorized users only! !DEVNOTE! Text
        //!DBTRANS! @m0312@ Password must contain a minimum of 8 characters including at least one lowercase character, one uppercase, one number, and one special character. !DEVNOTE! Action status reason
        //!DBTRANS! @m0313@ Create Account !DEVNOTE! Option label

        return (
            <AppContext.Consumer>
                {(context) => (
                <section className="app-login register">
                    <section className="inner">
                        <div className="closer">
                            <img src={require('../img/icon-close.png')} onClick={this.closeRegistration} alt="" />
                        </div>
                        {content}



                    </section>
                </section>
            )}
            </AppContext.Consumer>
        );
    }
}

export default isPage(RegisterPage);
RegisterPage.contextType = AppContext;



// WEBPACK FOOTER //
// ./src/containers/RegisterPage.js